export const PRODUCT_FRUITS_WORKSPACE_CODE =
  import.meta.env.VITE_PRODUCT_FRUITS_WORKSPACE_CODE?.trim() ?? '';

declare global {
  interface Window {
    productFruits?: {
      services?: {
        destroy?: () => void;
      };
    };
  }
}

export function destroyProductFruits(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.productFruits?.services?.destroy?.();
  } catch {
    // Ignore integration teardown failures during auth transitions.
  }
}

export function normalizeProductFruitsLanguage(language?: string): 'cs' | 'en' {
  const normalized = language?.toLowerCase() ?? 'en';

  return normalized.startsWith('cs') ? 'cs' : 'en';
}
